import {forEach} from 'lodash';


// ant design include normalize.css automatically
// this will cause conflict with the nitro ui
// calling below funciton will remove conflict style from page
const resetAntTheme = () => {
forEach(
    document.getElementsByTagName("style"),
    style => {
      if(style && style.innerHTML.split(/\n/)[0].includes('normalize.css'))
        {
          // console.log(style);
          if(typeof style.remove==='function'){
            //If support  is found
            style.remove();
          }
          else{
            //If not
            style.outerHTML='';
          }
        }
      }
  );
};

export default resetAntTheme;



// WEBPACK FOOTER //
// ./src/themes/resetAntTheme.js